<template>
    <div style="font-weight: 500;">
        <div style="padding: 12px 8px; border-radius: 12px;">
            <div style="font-size: 12px; font-weight: 700; white-space: nowrap;">오늘은
                <span style="color: var(--color-main);">{{ $GlobalStore.averageWalk() | comma }}걸음 </span>
            </div>
            <div style="font-size: 30px; font-weight: 700; margin-top: 10px; color: var(--color-main);">{{ calculateDistance }}<span style="font-size: 20px;">km</span></div>
            <div style="font-weight: 700; margin-top: 8px; font-size: 12px; line-height: 24px; color: #606060; white-space: nowrap;">축구 경기 기준 <span style="font-size: 14px; font-weight: 900; color: #210f03;">{{ calculateTime }}분</span>을 뛴 정도</div>
            <div style="margin-top: 10px;">
                <div class="progress-bar">
                    <div class="progress-bar-inner"></div>
                    <div :style="{ width: $GlobalStore.walkCount() / 100 + '%', backgroundSize: `${progressPercentage}% 100%` }" style="" class="progress">
                        <div class="progress-inner" :style="{ backgroundSize: `${progressPercentage}% 100%` }" style="max-width: 100%;"></div>
                        <div style="position: relative; width: 100%; height: 100%;">
                            <div :style="{ right: $GlobalStore.walkCount() >= 9500 ? '-10px' : '-16px' }" style="position: absolute; top: -8px;">
                                <img style="width: 25px;" :src="require('@/assets/img/pedometer_person.png')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div style="display: flex; justify-content: space-between;">
                    <div :class="$GlobalStore.walkCount() > 0 ? 'active' : 'active'" style="font-size: 12px; font-weight: 700; margin-top: 2px;">전반</div>
                    <div :class="$GlobalStore.walkCount() >= 5000 ? 'active' : 'un_active'" style="font-size: 12px; font-weight: 700; margin-top: 2px;">후반</div>
                    <div :class="$GlobalStore.walkCount() >= 10000 ? 'active' : 'un_active'" style="font-size: 12px; font-weight: 700; margin-top: 2px;">풀타임</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pedometer from '@/modules/Pedometer'
import moment from 'moment'
import { MY_VIEW_MODE } from '@/Constants'

export default {
    name: 'PedometerSimple',
    props: {
        signalRefresh: {
            type: Boolean,
            default: false
        },
        mode: {
            type: Number,
            default: MY_VIEW_MODE.ME
        },
        memberInfo: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        async signalRefresh() {
            await this.getPedoMeter();
        }
    },
    data() {
        return {
            MY_VIEW_MODE: MY_VIEW_MODE
        }
    },
    computed: {
        progressPercentage() {
            let per = parseInt(10000 / (this.$GlobalStore.walkCount() / 100)) / 10
            if (this.$GlobalStore.walkCount() > 10000) {
                per = 10
            }
            return per
        },
        calculateDistance() {
            const steps = this.$GlobalStore.walkCount()
            const stepsPerKm = 10000
            const distancePerKm = 7

            const distance = (steps / stepsPerKm) * distancePerKm

            return distance.toFixed(1)
        },
        calculateTime() {
            const steps = this.$GlobalStore.walkCount()
            const stepsPerDuration = 10000
            const durationPerSteps = 90

            const duration = (steps / stepsPerDuration) * durationPerSteps

            return Math.round(duration)
        },
        formattedDiff() {
            const diff = this.$GlobalStore.yesterdayDiff();
            if (diff === 0) {
                return '걸음'
            } else if (diff > 0) {
                return '걸음 +'
            } else {
                return '걸음 -'
            }
        },
    },
    methods: {
        async getPedoMeter() {
            try {
                // const todayPromise = Pedometer.getToday().then((res) => {
                //     let count = 0; // count가 오늘 걸음수
                //     if (res.data.length > 0) count = res.data[0].count;
                //
                //     this.$GlobalStore.setWalkCount(count)
                // });
                const last7DaysPromise = Pedometer.getLast(7).then(async (res) => {
                    const today = moment().format('YYYY-MM-DD');
                    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')
                    const todayData = res.data.find(item => moment(item.date, 'YYYY-MM-DD').format('YYYY-MM-DD') === today);
                    const yesterdayData = res.data.find(item => moment(item.date, 'YYYY-MM-DD').format('YYYY-MM-DD') === yesterday);
                    let count = 0; // 평균 걸음수(7일)
                    let yesterday_diff = 0; // 어제 오늘 걸음수 차이

                    if (res.data.length > 0) {
                        count = parseInt((res.data.reduce((acc, item) => acc + item.count, 0)) / 7);
                        this.$GlobalStore.setWalkCount(res.data[0].count);
                        if (todayData && yesterdayData) {
                            yesterday_diff = todayData.count - yesterdayData.count;
                        } else {
                            yesterday_diff = 0;
                        }
                    }

                    this.$GlobalStore.setAverageWalk(count)
                    this.$GlobalStore.setYesterdayDiff(yesterday_diff)

                    const parameters = {};
                    parameters.data = JSON.stringify(res.data);
                    await this.$Axios.post('/api/member/step/save', parameters);

                });
                await Promise.all([
                    // todayPromise,
                    last7DaysPromise]);
            } catch (error) {
                console.error('Error fetching pedometer data', error);
            }
        }
    },
    async created() {
        // if (!this.$GlobalStore.isGetPedoMeter()) {
        await this.getPedoMeter()
        // this.$GlobalStore.setIsGetPedoMeter()
        // }
    }

}
</script>

<style scoped>
.progress-bar {
    width: 100%;
    height: 11px;
    background: #A5A5A566;
    border-radius: 6px;
    /* overflow: hidden; */
    position: relative;
}

.progress-bar-inner {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 70%;
    margin-top: 2px;
    background-size: 10% 100%;
    background-image: linear-gradient(90deg, #ff853266 9%, transparent 9%), linear-gradient(90deg, transparent 1%, #ffffff66 1%);
}

.progress {
    height: 100%;
    width: 1%;
    /* Adjust this to change the progress level */
    background-color: #ff7700;
    max-width: 100%;
    border-radius: 6px;
    position: absolute;
}

.progress-inner {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    background-color: transparent;
    /* background-image: linear-gradient(90deg, #fff 9%, transparent 9%), linear-gradient(90deg, transparent 1%, var(--color-main) 1%); */
    height: 60%;
    margin-top: 2px;
    border-radius: 6px;
}

.active {
    color: var(--color-main)
}

.un_active {
    color: #d9d9d9;
}
</style>